import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import confetti from 'canvas-confetti';

// Badge notification with confetti celebration
export const showBadgeEarnedToast = (badge) => {
  // Fire confetti
  const defaults = {
    spread: 360,
    ticks: 100,
    gravity: 0,
    decay: 0.94,
    startVelocity: 30,
    colors: ['#FFD700', '#FFA500', '#FF6347', '#9370DB', '#3CB371']
  };

  function shoot() {
    confetti({
      ...defaults,
      particleCount: 40,
      scalar: 1.2,
      shapes: ['star']
    });

    confetti({
      ...defaults,
      particleCount: 25,
      scalar: 0.75,
      shapes: ['circle']
    });
  }

  // Fire confetti from multiple directions
  setTimeout(shoot, 0);
  setTimeout(shoot, 100);
  setTimeout(shoot, 200);

  // Show custom toast
  toast.custom((t) => (
    <div 
      className="bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 p-1 rounded-xl shadow-2xl animate-bounce-in"
      style={{
        animation: 'badge-pop 0.5s ease-out forwards',
      }}
    >
      <div className="bg-white rounded-lg p-4 flex items-center gap-4">
        <div className="relative">
          <div className="h-16 w-16 rounded-full bg-gradient-to-br from-amber-100 to-amber-300 flex items-center justify-center border-4 border-amber-400 shadow-lg animate-pulse">
            <span className="text-3xl">{badge.icon}</span>
          </div>
          <div className="absolute -top-1 -right-1 h-6 w-6 bg-emerald-500 rounded-full flex items-center justify-center">
            <span className="text-white text-xs">✓</span>
          </div>
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <span className="text-lg">🎉</span>
            <span className="font-bold text-amber-800">Achievement Unlocked!</span>
          </div>
          <h3 className="font-bold text-xl text-slate-800">{badge.name}</h3>
          <p className="text-sm text-slate-600">{badge.description}</p>
        </div>
      </div>
    </div>
  ), {
    duration: 5000,
    position: 'top-center',
  });
};

// Hook to track and show new badges
export const useNewBadgeNotification = (currentBadges, previousBadgeCount) => {
  const [shownBadges, setShownBadges] = useState(new Set());

  useEffect(() => {
    if (!currentBadges || currentBadges.length === 0) return;
    
    // Find badges we haven't shown yet
    currentBadges.forEach(badge => {
      if (!shownBadges.has(badge.id)) {
        // Check if this is a genuinely new badge (not from initial load)
        if (previousBadgeCount !== null && currentBadges.length > previousBadgeCount) {
          showBadgeEarnedToast(badge);
        }
        setShownBadges(prev => new Set([...prev, badge.id]));
      }
    });
  }, [currentBadges, previousBadgeCount, shownBadges]);
};

// Simple confetti burst for task completion
export const celebrateTaskCompletion = () => {
  confetti({
    particleCount: 30,
    spread: 60,
    origin: { y: 0.7 },
    colors: ['#22c55e', '#16a34a', '#15803d']
  });
};

export default showBadgeEarnedToast;
